module.exports = __webpack_public_path__ + "static/media/node.6664994a.svg";